<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  props: ['data'],
  data() {
    return {
      all_months: [  this.$t('statistics.january'), 
                this.$t('statistics.february'), 
                this.$t('statistics.march'), 
                this.$t('statistics.april'), 
                this.$t('statistics.may'), 
                this.$t('statistics.june'), 
                this.$t('statistics.july'), 
                this.$t('statistics.august'), 
                this.$t('statistics.september'), 
                this.$t('statistics.october'), 
                this.$t('statistics.november'), 
                this.$t('statistics.december') ]
    }
  },
  methods: {
      formatPrice(value) {
          let val = (value/1).toFixed(2).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },
      formatNumber(value){
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },
    labels(){
      var labels = []
      var today = new Date();
      for(var i = 5; i >= 0; i -= 1) {
        var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        labels.push((d.getMonth()+1).toString() + "/" + (d.getFullYear()).toString())
      }
      return labels;
    }
  },
  mounted() {
    var dis = this
    this.renderChart(
      {
        //labels: [ "Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December" ],
        labels: this.labels(),
        datasets: [
          {
            data: this.data,
            backgroundColor: "transparent",
            borderColor: "#F93C34",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 5,
            lineTension: 0,           
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {display: false},
        tooltips: {
          displayColors: false,
          callbacks: {
              label: function(t, d) {
                var lab = t.xLabel.substr(0, t.xLabel.indexOf('/')); 
                var xLabel =  dis.all_months[parseInt(lab) - 1]
                var yLabel = dis.formatPrice(t.yLabel) + " " + dis.$currency.symbol;
                return xLabel + " - " + yLabel;
              },
              title: function(t, d) {
                return ""
              }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
                fontColor: "#9CA3AF",
            },
            gridLines: {
              display: false,
            }
          }],
          yAxes: [{
            scaleLabel: { color: "#9CA3AF" },
            gridLines: {
              drawBorder: false,
              tickMarkLength: false,
              borderDash: [3, 3],
              color: "#BDBDBD"
            },
            ticks: {
                fontColor: "#9CA3AF",
                beginAtZero: true,
                callback: function(value, index, values) {
                  if(parseInt(value) >= 1000){
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " " + dis.$currency.symbol;
                  } else {
                    return value + " " + dis.$currency.symbol;
                  }
                }
            },
          }],
        }
      }
    );
  }
};
</script>